var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 40,
    viewBox: "0 0 49 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.58252 5.36583C0.58252 2.71755 2.74929 0.550781 5.39757 0.550781H43.9179C45.195 0.550781 46.4197 1.05808 47.3227 1.96108C48.2257 2.86407 48.733 4.0888 48.733 5.36583V34.2561C48.733 35.5331 48.2257 36.7579 47.3227 37.6609C46.4197 38.5639 45.195 39.0712 43.9179 39.0712H5.39757C4.12054 39.0712 2.89581 38.5639 1.99281 37.6609C1.08982 36.7579 0.58252 35.5331 0.58252 34.2561V5.36583ZM27.0653 27.0335L19.8427 19.811L5.39757 34.2561H43.9179L31.8803 22.2185L27.0653 27.0335ZM36.6954 17.4034C37.9724 17.4034 39.1971 16.8961 40.1001 15.9931C41.0031 15.0902 41.5104 13.8654 41.5104 12.5884C41.5104 11.3114 41.0031 10.0866 40.1001 9.18365C39.1971 8.28065 37.9724 7.77335 36.6954 7.77335C35.4183 7.77335 34.1936 8.28065 33.2906 9.18365C32.3876 10.0866 31.8803 11.3114 31.8803 12.5884C31.8803 13.8654 32.3876 15.0902 33.2906 15.9931C34.1936 16.8961 35.4183 17.4034 36.6954 17.4034Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImgIcon);
export default __webpack_public_path__ + "static/media/upload-img-icon.116c180a0fbfb44b4b7b05ae52c84166.svg";
export { ForwardRef as ReactComponent };